import { createElement } from 'react';
import { ElementFactory, Question, Serializer, SvgRegistry } from 'survey-core';
import { localization } from 'survey-creator-core';
import { PropertyGridEditorCollection } from 'survey-creator-react';
import { ReactQuestionFactory, SurveyQuestionElementBase } from 'survey-react-ui';
import AppCodeEditor from '../../../core-components/code-editor/CodeEditor';

const CUSTOM_TYPE = 'json';

class QuestionJsonEditorModel extends Question {
  getType() {
    return CUSTOM_TYPE;
  }
}

export function registerJSONEditor() {
  return ElementFactory.Instance.registerElement(CUSTOM_TYPE, (name) => {
    return new QuestionJsonEditorModel(name) as QuestionJsonEditorModel;
  });
}

// Specify display names for the question type and its properties
const locale = localization.getLocale('');
locale.qt[CUSTOM_TYPE] = 'Raw JSON';

// Register an SVG icon for the question type
const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><!--!Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2025 Fonticons, Inc.--><path d="M144 32c-44.2 0-80 35.8-80 80l0 53.5c0 12.7-5.1 24.9-14.1 33.9L4.7 244.7c-3 3-4.7 7.1-4.7 11.3s1.7 8.3 4.7 11.3l45.3 45.3c9 9 14.1 21.2 14.1 33.9L64 400c0 44.2 35.8 80 80 80l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0c-26.5 0-48-21.5-48-48l0-53.5c0-21.2-8.4-41.6-23.4-56.6L38.6 256l33.9-33.9c15-15 23.4-35.4 23.4-56.6L96 112c0-26.5 21.5-48 48-48l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0zm288 0l-64 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0c26.5 0 48 21.5 48 48l0 53.5c0 21.2 8.4 41.6 23.4 56.6L537.4 256l-33.9 33.9c-15 15-23.4 35.4-23.4 56.6l0 53.5c0 26.5-21.5 48-48 48l-64 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0c44.2 0 80-35.8 80-80l0-53.5c0-12.7 5.1-24.9 14.1-33.9l45.3-45.3c3-3 4.7-7.1 4.7-11.3s-1.7-8.3-4.7-11.3l-45.3-45.3c-9-9-14.1-21.2-14.1-33.9l0-53.5c0-44.2-35.8-80-80-80z"/></svg>`;

SvgRegistry.registerIconFromSvg(CUSTOM_TYPE, svg);

Serializer.addClass(
  CUSTOM_TYPE,
  [],
  function () {
    return new QuestionJsonEditorModel('');
  },
  'question'
);

class SurveyJSONEditor extends SurveyQuestionElementBase {
  constructor(props: unknown) {
    super(props);

    this.state = { value: this.question.value };
  }

  get question() {
    return this.questionBase as QuestionJsonEditorModel;
  }

  get value() {
    return this.question.value;
  }

  get style() {
    return this.question['readOnly'] ? 'no-pointer' : undefined;
  }

  handleChange = (data: string) => {
    this.question.value = JSON.parse(data);
  };

  renderElement() {
    return createElement(AppCodeEditor, {
      id: this.question.name + '-json-editor',
      mode: 'json',
      className: this.style,
      value: JSON.stringify(this.value, null, 2),
      setValue: (json: string) => this.handleChange(json),
      readOnly: this.question['readOnly']
    });
  }
}

export default ReactQuestionFactory.Instance.registerQuestion(CUSTOM_TYPE, (props) =>
  createElement(SurveyJSONEditor, props)
);

PropertyGridEditorCollection.register({
  fit: function (prop) {
    return prop.type === 'json';
  },
  getJSON: function () {
    return { type: 'json' };
  }
});
